<template>
    <header class="default-header">
  
      <div class="header-inner">
  
        <div
          class="header-left"
          :style="{
            marginLeft:
              `calc(50% - ${props.offset}px)`
          }"
        >
  
          <img
            src="../assets/hr3logo.png"
            alt="HR3"
            class="header-logo"
            @click="goToFeed"
          />
  
  
          <button
            class="back-button"
            type="button"
            aria-label="Назад"
            @click="goBack"
          >
            <img
              src="../assets/back-icon.png"
              alt=""
              class="back-icon"
            />
          </button>
  
  
          <div class="header-title-wrapper">
  
            <template v-if="!props.loading">
  
              <div class="header-title-block">
  
                <h1 class="header-title">
                  {{ props.title }}
                </h1>
  
                <p
                  v-if="props.subtitle"
                  class="header-subtitle"
                >
                  {{ props.subtitle }}
                </p>
  
              </div>
  
            </template>
  
  
            <template v-else>
  
              <div class="title-skeleton-wrap">
  
                <div
                  class="title-skeleton shimmer"
                ></div>
  
                <div
                  v-if="props.subtitle"
                  class="subtitle-skeleton shimmer"
                ></div>
  
              </div>
  
            </template>
  
          </div>
  
        </div>
  
      </div>
  
  
      <div class="header-separator"></div>
  
    </header>
  </template>
  
  
  <script setup>
  
  import {
    defineProps,
    defineEmits
  } from "vue";
  
  import {
    useRouter
  } from "vue-router";
  
  
  const emit =
    defineEmits([
      "back"
    ]);
  
  
  const props =
    defineProps({
  
      title: {
        type: String,
        default: ""
      },
  
      subtitle: {
        type: String,
        default: ""
      },
  
      emitBack: {
        type: Boolean,
        default: false
      },
  
      offset: {
        type: Number,
        default: 600
      },
  
      loading: {
        type: Boolean,
        default: false
      }
  
    });
  
  
  const router =
    useRouter();
  
  
  const goBack = () => {
  
    if (props.emitBack) {
  
      emit("back");
  
      return;
  
    }
  
  
    if (
      window.history.length > 2
    ) {
  
      router.back();
  
    } else {
  
      router.push("/feed");
  
    }
  
  };
  
  
  const goToFeed = () => {
  
    router.push("/feed");
  
  };
  
  </script>
  
  
  <style scoped>
  
  /* ============================================================
     HEADER
  ============================================================ */
  
  .default-header {
    width: 100%;
    height: 70px;
  
    position: relative;
  
    display: flex;
    flex-direction: column;
    justify-content: center;
  
    background:
      rgba(29, 31, 36, 0.93);
  
    backdrop-filter:
      blur(18px)
      saturate(130%);
  
    -webkit-backdrop-filter:
      blur(18px)
      saturate(130%);
  
    box-shadow:
      0
      2px
      18px
      rgba(0, 0, 0, 0.06);
  
    transition:
      background 0.25s ease,
      box-shadow 0.25s ease;
  }
  
  
  html[data-theme="light"]
  .default-header {
    background:
      rgba(255, 255, 255, 0.94);
  
    box-shadow:
      0
      2px
      18px
      rgba(20, 30, 45, 0.035);
  }
  
  
  /* ============================================================
     INNER
  ============================================================ */
  
  .header-inner {
    width: 100%;
    height: 100%;
  
    display: flex;
    align-items: center;
  
    padding:
      0
      20px;
  }
  
  
  .header-left {
    width: 1200px;
  
    display: flex;
    align-items: center;
  
    padding:
      0
      20px;
  }
  
  
  /* ============================================================
     LOGO
  ============================================================ */
  
  .header-logo {
    width: 40px;
    height: auto;
  
    object-fit:
      contain;
  
    cursor:
      pointer;
  
    margin-left:
      -20px;
  
    margin-right:
      40px;
  
    transition:
      transform 0.22s ease,
      opacity 0.22s ease;
  }
  
  
  .header-logo:hover {
    transform:
      scale(1.06);
  }
  
  
  /* ============================================================
     BACK BUTTON
  ============================================================ */
  
  .back-button {
    width: 36px;
    height: 36px;
  
    flex:
      0
      0
      36px;
  
    padding:
      8px;
  
    display: flex;
    align-items: center;
    justify-content: center;
  
    margin-right:
      16px;
  
    background:
      rgba(255, 255, 255, 0.04);
  
    border:
      1px solid
      rgba(255, 255, 255, 0.055);
  
    border-radius:
      11px;
  
    outline:
      none;
  
    cursor:
      pointer;
  
    transition:
      transform 0.18s ease,
      background-color 0.18s ease,
      border-color 0.18s ease;
  }
  
  
  .back-button:hover {
    transform:
      translateX(-1px);
  
    background:
      rgba(255, 255, 255, 0.065);
  
    border-color:
      rgba(255, 255, 255, 0.085);
  }
  
  
  .back-button:active {
    transform:
      scale(0.96);
  }
  
  
  html[data-theme="light"]
  .back-button {
    background:
      #f4f6f8;
  
    border-color:
      rgba(35, 50, 70, 0.055);
  }
  
  
  html[data-theme="light"]
  .back-button:hover {
    background:
      #edf0f3;
  }
  
  
  /* ============================================================
     BACK ICON
  ============================================================ */
  
  .back-icon {
    width: 15px;
    height: 15px;
  
    object-fit:
      contain;
  
    flex-shrink:
      0;
  
    opacity:
      0.88;
  
    transition:
      transform 0.18s ease,
      opacity 0.18s ease;
  }
  
  
  .back-button:hover
  .back-icon {
    transform:
      translateX(-1px);
  
    opacity:
      1;
  }
  
  
  html[data-theme="light"]
  .back-icon {
    filter:
      invert(1);
  }
  
  
  /* ============================================================
     TITLE WRAPPER
  ============================================================ */
  
  .header-title-wrapper {
    min-height:
      34px;
  
    display:
      flex;
  
    align-items:
      center;
  
    min-width:
      0;
  }
  
  
  .header-title-block {
    min-width:
      0;
  
    display:
      flex;
  
    flex-direction:
      column;
  
    justify-content:
      center;
  }
  
  
  /* ============================================================
     TITLE
  ============================================================ */
  
  .header-title {
    max-width:
      650px;
  
    margin:
      0;
  
    overflow:
      hidden;
  
    color:
      #f0f1f3;
  
    font-family:
      "Eastman-Bold",
      sans-serif;
  
    font-size:
      13px;
  
    line-height:
      1.15;
  
    letter-spacing:
      -0.1px;
  
    white-space:
      nowrap;
  
    text-overflow:
      ellipsis;
  }
  
  
  html[data-theme="light"]
  .header-title {
    color:
      #30343a;
  }
  
  
  /* ============================================================
     SUBTITLE
  ============================================================ */
  
  .header-subtitle {
    max-width:
      650px;
  
    margin:
      3px
      0
      0;
  
    overflow:
      hidden;
  
    color:
      #858a93;
  
    font-family:
      "Eastman-Regular",
      sans-serif;
  
    font-size:
      9px;
  
    line-height:
      1.2;
  
    letter-spacing:
      0;
  
    white-space:
      nowrap;
  
    text-overflow:
      ellipsis;
  }
  
  
  html[data-theme="light"]
  .header-subtitle {
    color:
      #9298a0;
  }
  
  
  /* ============================================================
     SEPARATOR
  ============================================================ */
  
  .header-separator {
    position:
      absolute;
  
    left:
      0;
  
    right:
      0;
  
    bottom:
      0;
  
    height:
      1px;
  
    background:
      linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.065),
        transparent
      );
  }
  
  
  html[data-theme="light"]
  .header-separator {
    background:
      linear-gradient(
        90deg,
        transparent,
        rgba(30, 45, 65, 0.08),
        transparent
      );
  }
  
  
  /* ============================================================
     SKELETON
  ============================================================ */
  
  .title-skeleton-wrap {
    display:
      flex;
  
    flex-direction:
      column;
  
    gap:
      5px;
  }
  
  
  .title-skeleton {
    position:
      relative;
  
    width:
      150px;
  
    height:
      11px;
  
    overflow:
      hidden;
  
    background:
      #34363b;
  
    border-radius:
      6px;
  }
  
  
  .subtitle-skeleton {
    position:
      relative;
  
    width:
      82px;
  
    height:
      7px;
  
    overflow:
      hidden;
  
    background:
      #2c2e33;
  
    border-radius:
      5px;
  }
  
  
  html[data-theme="light"]
  .title-skeleton {
    background:
      #e0e3e7;
  }
  
  
  html[data-theme="light"]
  .subtitle-skeleton {
    background:
      #eceef1;
  }
  
  
  .shimmer::before {
    content:
      "";
  
    position:
      absolute;
  
    inset:
      0;
  
    transform:
      translateX(-100%);
  
    background:
      linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.22),
        transparent
      );
  
    animation:
      shimmer
      1.4s
      linear
      infinite;
  }
  
  
  @keyframes shimmer {
  
    to {
      transform:
        translateX(100%);
    }
  
  }
  
  
  /* ============================================================
     MOBILE
  ============================================================ */
  
  @media (max-width: 768px) {
  
    .default-header {
      height:
        60px;
    }
  
  
    .header-inner {
      padding:
        0
        16px;
    }
  
  
    .header-left {
      width:
        100%;
  
      margin-left:
        0 !important;
  
      padding:
        0;
    }
  
  
    .header-logo {
      width:
        32px;
  
      margin-left:
        0;
  
      margin-right:
        14px;
    }
  
  
    .back-button {
      width:
        34px;
  
      height:
        34px;
  
      flex-basis:
        34px;
  
      margin-right:
        12px;
    }
  
  
    .back-icon {
      width:
        14px;
  
      height:
        14px;
    }
  
  
    .header-title-wrapper {
      min-width:
        0;
  
      flex:
        1;
    }
  
  
    .header-title-block {
      min-width:
        0;
    }
  
  
    .header-title {
      max-width:
        230px;
  
      font-size:
        12px;
    }
  
  
    .header-subtitle {
      max-width:
        230px;
  
      margin-top:
        2px;
  
      font-size:
        8px;
    }
  
  }
  
  
  /* ============================================================
     REDUCED MOTION
  ============================================================ */
  
  @media (prefers-reduced-motion: reduce) {
  
    .default-header,
    .header-logo,
    .back-button,
    .back-icon {
      transition:
        none;
    }
  
  
    .shimmer::before {
      animation:
        none;
    }
  
  }
  
  </style>